import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { momentSchedules } from '../../../v3/momentSchedules'

type MomentDeleteParams<TDeletionMeta extends Record<string, unknown>> = {
  momentId: string
  scheduleId: string
  meta?: TDeletionMeta
}

type MutationParams<TDeletionMeta extends Record<string, unknown>> = {
  onMutate?: (params: MomentDeleteParams<TDeletionMeta>) => void
  onSuccess?: (data: void, params: MomentDeleteParams<TDeletionMeta>) => void
}

type UseDeleteResult<TDeletionMeta extends Record<string, unknown>> =
  UseMutationResult<void, unknown, MomentDeleteParams<TDeletionMeta>, unknown>

export function useDeleteMomentScheduleMutation<
  TDeletionMeta extends Record<string, unknown>,
>({
  onMutate,
  onSuccess,
}: MutationParams<TDeletionMeta>): UseDeleteResult<TDeletionMeta> {
  return useMutation({
    mutationFn: ({ scheduleId }: MomentDeleteParams<TDeletionMeta>) =>
      momentSchedules.delete({
        params: {
          path: { moment_schedule_id: scheduleId },
        },
      }),
    onSuccess,
    onMutate,
  })
}
